import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook';

import { GTM_ENABLED } from '../environment';

type AnalyticsEvent = { event: string; value?: unknown };
type AnalyticsHook = (data: AnalyticsEvent) => void;
export const useAnalytics = (): AnalyticsHook => {
  return GTM_ENABLED ? useGTMDispatch() : console.log;
};
